import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Box, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LanguageSelectorDialog, LanguageSelectorMenuItem } from '../../components/languageSelector/LanguageSelector';
import { useAuth } from '../../context/AuthContext';
import { UserRole } from '../../enums/user';
import { CompanyName, PersonName } from '../../components/header/styles';

const ProfileHeader = () => {
  const { t: tProfile } = useTranslation('profile');
  const { t: tNavigation } = useTranslation('navigation');
  const { user, SignOut } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [languageDialogOpen, setLanguageDialogOpen] = useState(false);
  const role = Number(user?.user?.role);
  const canAccessDashboard = [UserRole.sAdmin, UserRole.admin, UserRole.group_responsible].includes(role);
  const firstName = user?.user?.first_name ?? '';
  const lastName = user?.user?.last_name ?? '';
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  const closeMenu = () => setAnchorEl(null);
  const openLanguageDialog = () => {
    closeMenu();
    setLanguageDialogOpen(true);
  };

  return (
    <>
      <Box
        component="header"
        sx={{
          minHeight: 50,
          flexShrink: 0,
          padding: '1em',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '1em',
          '@media (max-width: 359px)': {
            padding: '1em .5em',
          },
          backgroundColor: '#191B35',
          color: '#FFF',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {tProfile('title')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '.5em' }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}>
            <Tooltip enterTouchDelay={0} leaveTouchDelay={2000} arrow title={`${user?.user?.first_name} ${user?.user?.last_name }` } >
              <PersonName style={{color: '#FFF', textAlign: 'right' , fontWeight: '700' }}>{user?.user?.first_name} {user?.user?.last_name}</PersonName>
            </Tooltip>

            <CompanyName style={{color: '#FFF', textAlign: 'right' }}>{user?.company_visited?.name_company}</CompanyName>
          </div>
          <IconButton onClick={(event) => setAnchorEl(event.currentTarget)} size="small" aria-label={String(tNavigation('accountMenu'))}>
            <Avatar sx={{ background: 'linear-gradient(318deg, #00B2B5 16.44%, #96FFD2 85.22%)', color: '#3C4043' }}>
              {initials || <PersonOutlineIcon />}
            </Avatar>
          </IconButton>
        </Box>
      </Box>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu} onClick={closeMenu}>
        <MenuItem onClick={() => navigate('/profile')}>
          <ListItemIcon><PersonOutlineIcon fontSize="small" /></ListItemIcon>
          {tNavigation('myProfile')}
        </MenuItem>
        {canAccessDashboard && (
          <MenuItem onClick={() => navigate('/admin')}>
            <ListItemIcon><DashboardOutlinedIcon fontSize="small" /></ListItemIcon>
            {tNavigation('dashboard')}
          </MenuItem>
        )}
        <MenuItem onClick={() => navigate('/welcome')}>
          <ListItemIcon><AssignmentOutlinedIcon fontSize="small" /></ListItemIcon>
          {tNavigation('goToSurvey')}
        </MenuItem>
        <LanguageSelectorMenuItem onOpen={openLanguageDialog} />
        <MenuItem onClick={() => SignOut()}>
          <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
          {tNavigation('signOut')}
        </MenuItem>
      </Menu>

      <LanguageSelectorDialog
        open={languageDialogOpen}
        onClose={() => setLanguageDialogOpen(false)}
      />
    </>
  );
};

export default ProfileHeader;
